import Vue from 'vue';
import { AlumniProfileModel } from '@/models/alumni-profile/alumni-profile.model';
import { UserInteractionModel } from '@/models/alumni-profile/user-interaction.model';
import { MutationTree } from 'vuex';
import { AlumniProfileState } from './state';
import { UserSettingsModel } from '@/models/alumni-profile/user-settings.model';

const mutations: MutationTree<AlumniProfileState> = {
  SET_ALUMNI_PROFILE(state, profile: AlumniProfileModel) {
    if (state.alumniProfile && state.alumniProfile.accessToken === profile.accessToken) {
      state.alumniProfile = { ...state.alumniProfile, ...profile };
    } else {
      state.alumniProfile = profile;
    }
  },
  SET_ALUMNI_PROFILE_TOKEN(state, token: string) {
    state.profileToken = token;
    localStorage.setItem('profileToken', token);
  },
  SET_PROFILES(state, profiles: AlumniProfileModel[]) {
    (profiles || []).forEach((profile: AlumniProfileModel) => {
      Vue.set(state.profiles, profile.dexId.toString(), {
        ...state.profiles[profile.dexId],
        ...profile,
      });
    });
  },
  SET_INTERACTION(state, userInteraction: UserInteractionModel) {
    if (state.alumniProfile) state.alumniProfile.userInteraction = userInteraction;
  },
  SET_USER_SETTINGS(state, userSettings: UserSettingsModel) {
    if (state.alumniProfile) {
      state.alumniProfile = { ...state.alumniProfile, userSettings };
    }
  },
};

export default mutations;
